import Stores from "Stores/index";

function filterByTableColumns<Item>(items: Item[], searchText: string) {
  if (items.length > 0) {
    const tableKeys: Array<keyof Item> = Object.keys(items[0]) as Array<keyof Item>;

    const regExp: RegExp = new RegExp(searchText, "mig");
    return items.filter((item: Item) =>
      tableKeys.some((tableKey: keyof Item) => {
        if (tableKey === "type") {
          const locations = Object.entries(Stores.values.locationTypes).filter(
            ([locKey, locValue]: [string, number]) => {
              return Boolean(String(locKey).match(searchText));
            }
          );

          return locations.some(([locKey, locValue]: [string, number]) => locValue === (item[tableKey] as any));
        } else if (tableKey === "aliasNames") {
          return item[tableKey].find(
            (aliasName: any) =>
              Boolean(String(aliasName.name).match(searchText)) || Boolean(String(aliasName.fullName).match(searchText))
          );
        } else {
          return Boolean(String(item[tableKey]).match(regExp));
        }
      })
    );
  } else {
    return [];
  }
}

export default filterByTableColumns;
